// src/assets/ts/announcementItems.ts
import type { IRItem, NewsItem } from "../../types/announcement";

const financialPdf2023 = "/pdf/決算公告（2023年3月期）_株式会社Bang.pdf";
const financialPdf2024 = "/pdf/決算公告（2024年3月期）_株式会社Bang.pdf";
const financialPdf2025 = "/pdf/決算公告（2025年3月期）_株式会社Bang.pdf";
const financialPdf2026 = "/pdf/決算公告（2026年3月期）_株式会社Bang.pdf";

/**
 * mockNewsItemsの書き方説明
 *
 * NewsItemオブジェクトの構造：
 * - type: "text" | "link" - アイテムの種類を指定
 * - time: string - 日付を"YYYY.MM.DD"形式で指定
 * - content: string - お知らせの内容テキスト
 * - url: string - リンク先URL（type が "text" の場合は空文字列）
 *
 * 例：
 * {
 *   type: "text",
 *   time: "2025.08.18",
 *   content: "保険代理店化にともないサイトリニューアルいたしました。",
 *   url: "",
 * }
 * {
 *   type: "pdf",
 *   time: "2025.07.13",
 *   content:
 *   	"お知らせの見出しがこちらですお知らせの見出しがこちらですお知らせの見出しがこちらです",
 *   url: "https://example.com/sample.pdf",
 * }
 * {
 *   type: "link",
 *   time: "2025.07.12",
 *   content:
 *   	"お知らせの見出しがこちらですお知らせの見出しがこちらですお知らせの見出しがこちらですお知らせの見出しがこちらですお知らせの見出しがこちらですお知らせの見出しがこちらです",
 *   url: "https://example.com/detail",
	}
 */
export const mockNewsItems: NewsItem[] = [
	{
		type: "text",
		time: "2026.08.03",
		content: "7月28日に熊本県を中心として発生した地震により被災された皆さまに、心よりお見舞いを申し上げます。",
		url: "",
	},
	{
		type: "link",
		time: "2026.06.15",
		content: "2026年3月期の決算公告を掲載いたしました。",
		url: "/ir",
	},
	{
		type: "text",
		time: "2025.08.18",
		content: "保険代理店化にともないサイトリニューアルいたしました。",
		url: "",
	}
];

// IR専用のモックデータ
export const mockIRItems: IRItem[] = [
	{
		type: "pdf",
		time: "2026.06.15",
		content: "決算公告（2026年3月期）-PDF",
		url: financialPdf2026,
	},
	{
		type: "pdf",
		time: "2025.06.25",
		content: "決算公告（2025年3月期）-PDF",
		url: financialPdf2025,
	},
	{
		type: "pdf",
		time: "2024.06.25",
		content: "決算公告（2024年3月期）-PDF",
		url: financialPdf2024,
	},
	{
		type: "pdf",
		time: "2023.06.27",
		content: "決算公告（2023年3月期）-PDF",
		url: financialPdf2023,
	},
];
